import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { toTime } from '../../../../../utils/generalHelpers';
import styles from './style.module.scss';
import Webcam from 'react-webcam';
import { RefObject } from 'react';

/** Below this many seconds left, the countdown circle takes over from the clock. */
const FINAL_COUNTDOWN = 5;

interface Props {
    counter: number;
    onExit: () => void;
    showCountdown: boolean;
    webcamRef: RefObject<Webcam>;
    onCameraChange: (isActive: boolean) => void;
};

/** The proctoring sidebar: live camera preview, remaining time and the exit button. */
function ExamStream(props: Props) {
    const {
        onExit,
        counter,
        webcamRef,
        showCountdown,
        onCameraChange,
    } = props;

    const { hours, minutes, seconds } = toTime(counter);

    return (
        <div className={styles.stream}>
            <div className={styles.stream_video}>
                <Webcam
                    audio
                    muted
                    ref={webcamRef}
                    onUserMedia={stream => onCameraChange(stream.active)}
                    onUserMediaError={() => onCameraChange(false)}
                />
            </div>
            <div className={styles.stream_detail}>
                <span className={styles.stream_detail_live}></span>
                <span className={styles.stream_detail_countdown}>{`${hours}:${minutes}:${seconds}`}</span>
            </div>
            {showCountdown && counter <= FINAL_COUNTDOWN && <div className={styles.stream_countdown}>
                <CountdownCircleTimer
                    isPlaying
                    size={80}
                    strokeWidth={6}
                    duration={FINAL_COUNTDOWN}
                    colorsTime={[5, 2, 0]}
                    colors={['#004777', '#A30000', '#C4314B']}
                >
                    {({ remainingTime }) => remainingTime}
                </CountdownCircleTimer>
            </div>}
            <div className={styles.stream_exit} onClick={onExit}>
                <span>Exit exam</span>
            </div>
        </div>
    )
};

export default ExamStream;
